import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, DataTable } from "../components/Table";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

const Chk = ({ ok }) => ok ? <CheckCircle size={16} weight="fill" color="#34C759" /> : <XCircle size={16} weight="fill" color="#FF3B30" />;
function scoreColor(s) { return s >= 85 ? "#34C759" : s >= 70 ? "#5AC8FA" : s >= 55 ? "#FF9500" : "#FF3B30"; }

export default function DeviceHealth() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/devices/health/summary").then((r) => setRows(r.data.devices)); }, []);

  const columns = [
    { key: "vehicle_number", header: "Vehicle", render: (r) => <span className="font-semibold">{r.vehicle_number}</span> },
    { key: "model", header: "Device" },
    { key: "score", header: "Health", render: (r) => (
      <span className="font-display font-bold text-lg" style={{ color: scoreColor(r.score) }}>{r.score}</span>
    )},
    { key: "gps", header: "GPS", render: (r) => <Chk ok={r.gps} /> },
    { key: "gsm", header: "GSM", render: (r) => <Chk ok={r.gsm} /> },
    { key: "power", header: "Power", render: (r) => <Chk ok={r.power} /> },
    { key: "battery", header: "Battery", render: (r) => <Chk ok={r.battery} /> },
    { key: "firmware_ok", header: "Firmware", render: (r) => <Chk ok={r.firmware_ok} /> },
    { key: "online", header: "Comms", render: (r) => <Chk ok={r.online} /> },
  ];

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="Device Health" subtitle="Sorted by lowest health score first" />
      <DataTable testid="device-health-table" columns={columns} rows={rows} />
    </div>
  );
}
